import { type ComponentProps, type FC } from "react";

import { Badge } from "@fronterahealth/frontera-ui-components";

/**
 * Mosaic's Badge pulses for the "ai" and "processing" appearances. QA Rules uses
 * those colors for static labels, so switch the animation off (keeping the colors).
 */
export const StillBadge: FC<ComponentProps<typeof Badge>> = ({ className = "", ...props }) => (
  <Badge {...props} className={`animate-none! ${className}`} />
);
